import {doc} from './docs.js';
import ZScript from "../custom/ZScript.js";

doc(
    "script",
    {
    },
    "Write script to control some other object that uses scripting", 
    () => 0,
    {
        tags: "Scripting",
        inlets: 0
    }
);

export const script  = (object) => {
    let zscript = new ZScript(object); 
    zscript.width = 350;
    zscript.height= 350;
    object.effect = zscript;
    object.needsLoad = true;

    return () => {
        zscript.code = zscript.code;
    };
};

